module.exports = __webpack_public_path__ + "static/herologo-249bb12b87a0dc641b0fcca88a8ee294.svg";